export const TypePublic = [
  'Permanent',
  'Interimaire',
] as const

export type TypePublic = typeof TypePublic[number]

export const TypePublicLibelle: {
  [key in TypePublic]: string
} = {
  Permanent: 'Permanent',
  Interimaire: 'Intérimaire',
} as const
